module.exports = __webpack_public_path__ + "img/logo202109021.ffc8dd64.png";